export default ({
  pageState: { editorAdders, editorBlocks, editorBlocksOrder },
  data: { blockIds, blocks, success, updatedAt }
}) => {
  if (!success) return {};

  // if blocks were copied to another chapter
  if (!blockIds) {
    return {
      editorCopyBlocksLoading: false,
      editorCopyBlocksSuccess: true
    };
  }

  // if blocks were copied to this chapter
  return {
    editorAdders: [...editorAdders, ...blockIds.map(() => false)],
    editorBlocks: {
      ...editorBlocks,
      ...blocks
    },
    editorBlocksOrder: [...editorBlocksOrder, ...blockIds],
    editorCopyBlocksLoading: false,
    editorCopyBlocksSuccess: true,
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: true
  };
};
